class InfiniteScrollManager {
  constructor(container) {
    this.container = container;
    this.type = container.dataset.infiniteScroll;
    this.sectionId = container.dataset.sectionId;
    this.nextUrl = container.dataset.nextUrl || '';
    this.loading = false;

    this.sentinel = container.querySelector('[data-infinite-scroll-sentinel]');
    if (!this.nextUrl || !this.sentinel) return;

    this.createObserver();
  }

  createObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px 300px 0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadNextPage();
        }
      });
    }, options);

    this.observer.observe(this.sentinel);
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  buildUrl(url) {
    try {
      const fullUrl = new URL(url, window.location.origin);
      if (this.sectionId) {
        fullUrl.searchParams.set('section_id', this.sectionId);
      }
      return fullUrl.toString();
    } catch (e) {
      // Fallback para URLs relativas simples
      let finalUrl = url;
      const hasQuery = finalUrl.includes('?');
      if (this.sectionId) {
        finalUrl += (hasQuery ? '&' : '?') + 'section_id=' + encodeURIComponent(this.sectionId);
      }
      return finalUrl;
    }
  }

  async loadNextPage() {
    if (this.loading || !this.nextUrl) return;
    this.loading = true;
    this.container.classList.add('infinite-scroll--loading');

    const url = this.buildUrl(this.nextUrl);

    try {
      const response = await fetch(url, {
        credentials: 'same-origin'
      });
      const html = await response.text();

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;

      const nextContainer = wrapper.querySelector(
        `[data-infinite-scroll="${this.type}"][data-section-id="${this.sectionId}"]`
      ) || wrapper;

      this.appendItemsFrom(nextContainer);
      this.updateNextUrlFrom(nextContainer);
    } catch (e) {
      console.error('Infinite scroll load error', e);
      this.observer && this.observer.disconnect();
    } finally {
      this.loading = false;
      this.container.classList.remove('infinite-scroll--loading');
    }
  }

  appendItemsFrom(nextContainer) {
    let sourceListSelector;

    switch (this.type) {
      case 'collection':
        sourceListSelector = 'ul.grid.product-grid';
        break;
      case 'search':
        sourceListSelector = 'ul.grid.product-grid';
        break;
      case 'collections-list':
        sourceListSelector = 'ul.collection-list';
        break;
      default:
        return;
    }

    const currentList = this.container.querySelector(sourceListSelector);
    const nextList = nextContainer.querySelector(sourceListSelector);

    if (!currentList || !nextList) return;

    const newItems = Array.from(nextList.children);
    newItems.forEach((item) => currentList.appendChild(item));

    // Reaplica o filtro de disponibilidade por tamanho nos itens recém-anexados.
    if (window.FacetFiltersForm && typeof window.FacetFiltersForm.applySizeAvailabilityVisibility === 'function') {
      window.FacetFiltersForm.applySizeAvailabilityVisibility(window.location.search.slice(1));
    }

    // Re-inicializa Swiper nos novos cards, se disponível
    if (window.initProductCardSwipers) {
      window.initProductCardSwipers(this.container);
    }

    // Re-inicializa Quick Variant Selectors (incluindo mobile quick view)
    if (window.initQuickVariantSelectors) {
      window.initQuickVariantSelectors(this.container);
    }
  }

  updateNextUrlFrom(nextContainer) {
    const newNextUrl = nextContainer.dataset.nextUrl || '';
    this.nextUrl = newNextUrl;
    this.container.dataset.nextUrl = newNextUrl;

    if (!this.nextUrl && this.observer) {
      this.observer.disconnect();
      if (this.sentinel) {
        this.sentinel.remove();
      }
    }
  }
}

window.initInfiniteScrollManagers = function() {
  if (window.__infiniteScrollManagers && Array.isArray(window.__infiniteScrollManagers)) {
    window.__infiniteScrollManagers.forEach((manager) => manager.destroy());
  }

  const managers = [];
  const containers = document.querySelectorAll('[data-infinite-scroll]');
  containers.forEach((container) => {
    const manager = new InfiniteScrollManager(container);
    if (manager.sentinel && manager.nextUrl) {
      managers.push(manager);
    }
  });
  window.__infiniteScrollManagers = managers;
};

document.addEventListener('DOMContentLoaded', function() {
  window.initInfiniteScrollManagers();
});

